// libraries
import React from 'react';
import Route from 'react-router/lib/Route';
import store from 'store';

// actions
import {
    handleFinanceHomeRouteEnter,
    handleAccountCreatedRouteEnter
  } from './actions';

import FinanceHomeContainer from './FinanceHomeContainer.jsx';

const superOrFinanceRole = "superuser,financialofficer,hqfinancialofficer";

const routes = (
    <div>
        <Route path="finance"
        role={superOrFinanceRole}
        component={FinanceHomeContainer}
        onEnter={(nextState, replace, callback) =>
            store.dispatch(handleFinanceHomeRouteEnter(nextState, replace, callback))}
        /> 
        <Route path="finance/accountcreated"
        role={superOrFinanceRole}
        component={FinanceHomeContainer}
        onEnter={(nextState, replace, callback) =>
            store.dispatch(handleAccountCreatedRouteEnter(nextState, replace, callback))}
        />       
    </div>
  );
  
  export default routes;


// WEBPACK FOOTER //
// ./src/features/finance/routes.js